import { Collapse } from "@mui/material";
import PropTypes from "prop-types";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import globalStyles from "style";
import SidenavCollapse from "ui/Sidenav/SidenavCollapse";
import { LAST_PATH } from "constant";

function SidenavNested({ route }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const collapseName = location.pathname.replace("/", "");

  const handleClick = (value) => {
    setOpen(value);
  };
  useEffect(() => {
    if (!collapseName.includes(route.key)) {
      handleClick(false);
    }
  }, [collapseName]);
  const gobalClasses = globalStyles();
  return (
    <>
      <NavLink key={route.key} to={route.route} onClick={() => handleClick(true)}>
        <SidenavCollapse
          name={route.name}
          icon={route.icon}
          active={collapseName.includes(route.key)}
        >
          {open ? <ExpandLess /> : <ExpandMore />}
        </SidenavCollapse>
      </NavLink>
      <div>
        <Collapse in={open} timeout="auto" classes={gobalClasses.collapseMenu}>
          {route.collapse.map(
            (item) =>
              item.route !== route.route && (
                <NavLink
                  key={item.key}
                  to={item.route}
                  onClick={() => {
                    if (item.route !== "/logout") {
                      localStorage.setItem(LAST_PATH, item.route);
                    }
                  }}
                >
                  <SidenavCollapse
                    name={item.name}
                    icon={item.icon}
                    active={item.route.substring(1) === collapseName}
                    type="nested"
                  />
                </NavLink>
              )
          )}
        </Collapse>
      </div>
    </>
  );
}
SidenavNested.defaultProps = {};

SidenavNested.propTypes = {
  route: PropTypes.object.isRequired,
};

export default SidenavNested;
